import { Map } from 'immutable';
import _ from 'lodash';

import notifications from '../../components/Feedback/Notification';

const openNotification = (type, message, description) => {
  notifications[type]({
    message: message,
    description: description,
  });
};

const debug = process.env.REACT_APP_IS_DEBUG_ACTIVE;

export function clearToken() {
  localStorage.removeItem('id_token');
}

export function getToken() {
  try {
    const idToken = localStorage.getItem('id_token');
    return new Map({ idToken });
  } catch (err) {
    clearToken();
    return new Map();
  }
}

export function arrayEqual(array1, array2) {
  return array1.sort().toString() == array2.sort().toString();
}

export function timeDifference(givenTime) {
  givenTime = new Date(givenTime);
  const milliseconds = new Date().getTime() - givenTime.getTime();
  const numberEnding = (number) => {
    return number > 1 ? 's' : '';
  };
  const number = (num) => (num > 9 ? '' + num : '0' + num);
  const getTime = () => {
    let temp = Math.floor(milliseconds / 1000);
    const years = Math.floor(temp / 31536000);
    if (years) {
      const month = number(givenTime.getUTCMonth() + 1);
      const day = number(givenTime.getUTCDate());
      const year = givenTime.getUTCFullYear() % 100;
      return `${day}-${month}-${year}`;
    }
    const days = Math.floor((temp %= 31536000) / 86400);
    if (days) {
      if (days < 28) {
        return days + ' day' + numberEnding(days);
      } else {
        const months = [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec',
        ];
        const month = months[givenTime.getUTCMonth()];
        const day = number(givenTime.getUTCDate());
        return `${day} ${month}`;
      }
    }
    const hours = Math.floor((temp %= 86400) / 3600);
    if (hours) {
      return `${hours} hour${numberEnding(hours)} ago`;
    }
    const minutes = Math.floor((temp %= 3600) / 60);
    if (minutes) {
      return `${minutes} minute${numberEnding(minutes)} ago`;
    }
    return 'a few seconds ago';
  };
  return getTime();
}

export function stringToInt(value, defValue = 0) {
  if (!value) {
    return 0;
  } else if (!isNaN(value)) {
    return parseInt(value, 10);
  }
  return defValue;
}
export function stringToPosetiveInt(value, defValue = 0) {
  const val = stringToInt(value, defValue);
  return val > -1 ? val : defValue;
}

/*** AUTHENTICATION HELPER METHODS ***/
export function addPersistentData({ authenticate, remember = false }) {
  const storeObject = {
    authenticate: authenticate,
    remember: remember,
  };

  if (remember) {
    localStorage.setItem('authenticate', JSON.stringify(storeObject));
  } else {
    sessionStorage.setItem('authenticate', JSON.stringify(storeObject));
  }
}

export function removePersistentData() {
  localStorage.removeItem('authenticate');
  sessionStorage.removeItem('authenticate');
}

export function getAuthenticateData() {
  let jsonData =
    sessionStorage.getItem('authenticate') !== null &&
    sessionStorage.getItem('authenticate') !== undefined
      ? sessionStorage.getItem('authenticate')
      : localStorage.getItem('authenticate') !== null &&
        localStorage.getItem('authenticate') !== undefined
      ? localStorage.getItem('authenticate')
      : null;
  if (!_.isNil(jsonData)) {
    jsonData = JSON.parse(jsonData);
  }

  return jsonData;
}

export function updateTokenPersistentData(
  refreshToken = null,
  accessToken = null
) {
  const authenticateData = getAuthenticateData();

  // refreshToken - updateToken
  if (!_.isNil(refreshToken)) {
    authenticateData.authenticate.refreshToken = refreshToken;
  }

  // accessToken - updateToken
  if (!_.isNil(accessToken)) {
    authenticateData.authenticate.accessToken = accessToken;
  }

  addPersistentData({
    authenticate: authenticateData.authenticate,
    remember: authenticateData.remember,
  });
}

/* ************************************************ */

export function errorNotification(err) {
  if (debug === 'true') {
    openNotification(
      'error',
      'Attenzione',
      err.response.data?.slException?.message || 'Eccezione'
    );
    console.log(err.response.data);
  }
}

export function initSelectField(optionList, currOption) {
  if (
    optionList !== null &&
    optionList !== undefined &&
    currOption !== null &&
    currOption !== undefined
  ) {
    const optionToEnable = optionList.filter(
      (option) => option.id === currOption.id
    );

    if (optionToEnable.length > 0) {
      return optionToEnable[0].id;
    }
  }

  return null;
}

export function getSelectedPageAfterInsert(
  selectedPage,
  dataSource,
  itemsPerPage,
  totalItems
) {
  if (dataSource.length === itemsPerPage) {
    return Math.ceil((totalItems + 1) / itemsPerPage);
  }
  return selectedPage;
}

export function getSelectedPageAfterRemove(
  selectedPage,
  dataSource,
  selectedRows
) {
  if (dataSource.length === selectedRows.length) {
    if (selectedPage > 1) {
      return selectedPage - 1;
    }
  }
  return selectedPage;
}

export function dayWeek(props) {
  switch (props) {
    case 1:
      return 'Lunedì';
    case 2:
      return 'Martedì';
    case 3:
      return 'Mercoledì';
    case 4:
      return 'Giovedì';
    case 5:
      return 'Venerdì';
    case 6:
      return 'Sabato';
    case 7:
      return 'Domenica';
    default:
      return null;
  }
}
